import { multiPartPostJSON } from "../helpers/core";
import { postJSONBackgroundIdempotent } from "../helpers/idempotency";

export const create = (productId, params) =>
  postJSONBackgroundIdempotent(`OrderProduct/Create/${productId}`, {
    ...params,
    skip_price_recalculations: true
  });

export const update = (orderProductID, params) =>
  postJSONBackgroundIdempotent(`OrderProduct/Update/${orderProductID}`, {
    ...params,
    skip_price_recalculations: true
  });

export const uploadDocument = (
  productInstanceId,
  document_file,
  send_with_contract
) =>
  multiPartPostJSON(`OrderProduct/UploadDocument/${productInstanceId}`, {
    document_file,
    send_with_contract: send_with_contract ? 1 : 0
  });
